import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useFlag } from '@carnica/utils/hooks';
import { useListener } from "../useListener";
export var useOnlineStatus = function useOnlineStatus() {
  var _navigator;
  var isNavigatorOnlineAvailable = typeof window !== 'undefined' && typeof ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.onLine) === 'boolean';
  var _useFlag = useFlag(isNavigatorOnlineAvailable ? navigator.onLine : true),
    _useFlag2 = _slicedToArray(_useFlag, 2),
    isOnline = _useFlag2[0],
    setIsOnline = _useFlag2[1];
  var updateOnlineStatus = function updateOnlineStatus() {
    if (isNavigatorOnlineAvailable) {
      setIsOnline.set(navigator.onLine);
    }
  };
  useListener('online', updateOnlineStatus, {
    active: isNavigatorOnlineAvailable
  });
  useListener('offline', updateOnlineStatus, {
    active: isNavigatorOnlineAvailable
  });
  return isOnline;
};